export class ApplicationUi {
    Theme ?: string;
    BasePath ?: string;
    Language ?: string;
    Branding ?: string;
}
